import { deleteEmptyObj, formatDate } from '@/utils/utils'

const state = {
  page: 1,
  limit: 15,
  total: 0,
  class_id: '',
  mark_status: 0, // 1 :未发布 -99:删除 100:发布 -100:彻底删除'
  max_score: undefined,
  min_score: undefined,
  name: '',
  status: '',
  date: [],
  username: '',
  updated_at_from: null,
  updated_at_to: null
}

const actions = {
  // 获取作品管理数据
  async myWorkGetData({ commit, state }) {
    const page = state.page

    const data = {
      class_id: state.class_id,
      mark_status: state.mark_status,
      max_score: state.max_score * 20,
      min_score: state.min_score * 20,
      name: state.name,
      status: state.status,
      updated_at_from:
        state.updated_at_from && formatDate(state.updated_at_from, 'U'),
      updated_at_to:
        state.updated_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      username: state.username
    }
    deleteEmptyObj(data)
    const res = await API.get(
      `/edu/zone/work/manager/student/works?page=${page}`,
      data
    )
    commit('setState', {
      module: 'myWork',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 获取作品互评信息
  async workMutualEvaluationData({ commit }, playload) {
    const page = state.page

    const data = {
      name: state.name,
      status: state.status,
      updated_at_from:
        state.updated_at_from && formatDate(state.updated_at_from, 'U'),
      updated_at_to:
        state.updated_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      username: state.username
    }
    deleteEmptyObj(data)
    const res = await API.get(
      `/edu/zone/work/manager/mutual/works?page=${page}`,
      data
    )
    commit('setState', {
      module: 'myWork',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 导出
  async myWorkExcel({ commit, state, rootState }) {
    const data = {
      class_id: state.class_id,
      mark_status: state.mark_status,
      max_score: state.max_score * 20,
      min_score: state.min_score * 20,
      name: state.name,
      status: state.status,
      updated_at_from:
        state.updated_at_from && formatDate(state.updated_at_from, 'U'),
      updated_at_to:
        state.updated_at_to &&
        formatDate(+new Date(state.created_at_to) / 1000 + 24 * 60 * 60, 'U'),
      username: state.username,
      language: rootState.locale
    }
    deleteEmptyObj(data)
    const res = await API.get(
      `/edu/zone/work/manager/student/works/excel`,
      data,
      { responseType: 'arraybuffer', timeout: 0 }
    )
    return res
  },
  // 保存自评评分
  async workManageSaveSelfScore({ commit }, playload) {
    const res = await API.patch(
      `/edu/zone/work/manager/self/works/scores`,
      playload
    )
    return res
  },
  // 保存互评评分
  async workManageSaveMutualScore({ commit }, playload) {
    const res = await API.patch(
      `/edu/zone/work/manager/mutual/works/scores`,
      playload
    )
    return res
  }
}

const mutations = {
  myWorkInit(state) {
    state.page = 1
    state.class_id = ''
    state.mark_status = ''
    state.max_score = undefined
    state.min_score = undefined
    state.name = ''
    state.status = ''
    state.date = []
    state.username = ''
    state.updated_at_to = null
    state.updated_at_from = null
  }
}

export default {
  state,
  actions,
  mutations
}
